import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RefreshStateService {
  public readonly result$ = new BehaviorSubject<boolean | null>(null);
  private _isRefreshing = false;

  public get isRefreshing(): boolean {
    return this._isRefreshing;
  }

  public startRefresh(): void {
    this._isRefreshing = true;
    this.result$.next(null);
  }

  public completeRefresh(success: boolean): void {
    this._isRefreshing = false;
    this.result$.next(success);
  }
}
